// SEND-333 — the ONE gable pick, shared by the main Hover door and the ISS
// Hover door (no second copy). "What are the gables?" — B&B, Shake, or Leave
// as lap. No default; the caller keeps the Agree button locked until a pick.
// Both doors read the `hover-gable-*` test ids this component renders.
import React from "react";

const OPTIONS = [
  ["bnb", "Board & Batten"],
  ["shake", "Shake"],
  ["lap", "Leave as lap"],
];

export default function GableCladdingPick({ value, onChange }) {
  return (
    <div className="mt-4" data-testid="hover-gable-cladding-pick">
      <div className="text-xs font-bold uppercase tracking-wider text-[var(--ink-2)] mb-2">
        What are the gables? <span className="text-[#DC2626]">Pick one</span>
      </div>
      <div className="flex gap-2">
        {OPTIONS.map(([v, lbl]) => (
          <button
            key={v}
            type="button"
            onClick={() => onChange(v)}
            data-testid={`hover-gable-${v}`}
            aria-pressed={value === v}
            className={`flex-1 px-3 py-2 text-sm font-bold uppercase tracking-wider border ${
              value === v
                ? "bg-[var(--brand)] text-[var(--on-brand)] border-[var(--brand)]"
                : "bg-[var(--surface)] text-[var(--ink-2)] border-[var(--border)] hover:bg-[var(--bg-app)]"
            }`}
          >
            {lbl}
          </button>
        ))}
      </div>
      <div className="text-[10px] text-[var(--muted)] mt-1.5 leading-snug">
        B&amp;B or shake re-clads every gable; "Leave as lap" keeps the gables
        the siding the import writes. An orphan gable is flagged, not re-clad.
      </div>
    </div>
  );
}
